var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22.383 21.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.425 21.21a1.44 1.44 0 0 0 2.04 0l9.58-9.58c.45-.45.45-1.177 0-1.626l-9.58-9.58a1.44 1.44 0 0 0-2.04 0 1.44 1.44 0 0 0 0 2.04l8.347 8.358-8.358 8.358a1.437 1.437 0 0 0 .011 2.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.425 21.21a1.44 1.44 0 0 0 2.04 0l9.58-9.58c.45-.45.45-1.177 0-1.626L2.466.424a1.44 1.44 0 0 0-2.04 0 1.44 1.44 0 0 0 0 2.04l8.347 8.358L.414 19.18a1.437 1.437 0 0 0 .011 2.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRightArrow);
export default __webpack_public_path__ + "static/media/DoubleRightArrow.3b30a05b95152023a9cbea609dd2f1c8.svg";
export { ForwardRef as ReactComponent };